import React from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { GET_CURRENT_PAGE } from "../Utils/types";

function PaginatedItems({ totalCount, perPageData }) {
  const dispatch = useDispatch();
  const globalReducer = useSelector((state) => state?.globalReducer);

  const handlePageClick = (event) => {
    dispatch({
      type: GET_CURRENT_PAGE,
      payload: event.selected + 1,
    });
  };

  return (
    <>
      <ReactPaginate
        breakLabel="..."
        nextLabel={totalCount > perPageData ? "Next >" : ""}
        onPageChange={handlePageClick}
        pageRangeDisplayed={perPageData}
        pageCount={Math.ceil(totalCount / perPageData)}
        previousLabel={totalCount > perPageData ? "< Previous" : ""}
        renderOnZeroPageCount={null}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={totalCount > perPageData ? "page-link" : ""}
        nextClassName={"page-item"}
        nextLinkClassName={totalCount > perPageData ? "page-link" : ""}
        activeClassName={"active"}
        forcePage={globalReducer?.getCurrentPage - 1}
      />
    </>
  );
}

export default PaginatedItems;
